import { render, staticRenderFns } from "./IcoFaceNeutral.vue?vue&type=template&id=03f77e32"
import script from "./IcoFaceNeutral.vue?vue&type=script&lang=js"
export * from "./IcoFaceNeutral.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports